const FindFileExtention = (url) => {
    const arr = url.split('.')
    return arr[1]
}

export { FindFileExtention }